// extracted by extract-css-chunks-webpack-plugin
module.exports = {"side-scroller":"side-scroller___xbXVv","scroller":"scroller___XyPW7","container":"container___ZTdj6","previous":"previous___GwSmI","next":"next____2M5W"};